import { useCallback, useEffect, useState } from 'react';
import { useMessageContext } from '@/context';
import { AppButton, AppCollapsible, AppModal, AppModalProps, Flex } from '../common';
import { useTranslation } from 'react-i18next';

export const MessageModal: React.FC<AppModalProps> = ({ hide, open, ...rest }) => {

  const [loadingId, setLoadingId] = useState(null);
  const { unreadForceMessages, markAsRead, refresh } = useMessageContext();

  const [t] = useTranslation(['common']);

  const handleReadClick = useCallback(async (item: InboxMessageEntity) => {
    setLoadingId(item.id);
    await markAsRead(item.id).finally(() => setLoadingId(null));
    refresh();
  }, [setLoadingId, markAsRead, refresh]);

  const unreadItems = unreadForceMessages
    .map(item => ({
      title: item?.message?.subject,
      content: item?.message?.body,
      contentAfter: (
        <Flex className="ms-auto">
          <AppButton
            className="px-2"
            appVariant="nurture"
            loading={loadingId === item.id}
            onClick={handleReadClick.bind(this, item)}
          >
            {t('common:labels.read-message')}
          </AppButton>
        </Flex>
      )
    }));

  useEffect(() => {
    if (unreadForceMessages.length === 0) {
      hide();
    }
  }, [unreadForceMessages]);

  return (
    <AppModal
      footer={null}
      width="90%"
      variant="glass"
      onCancel={null}
      closable={false}
      open={open}
      style={{ maxWidth: '700px' }}
      title={t('common:messages.unread-message', { value: unreadForceMessages.length })}
      {...rest}>
      <Flex direction="column">
        <AppCollapsible inject items={unreadItems} />
      </Flex>
    </AppModal>
  );
};

export default MessageModal;
